import clsx from 'clsx';

// Utils
import useUserRole from '@/utils/hooks/user/useUserRole';

// Lib
import { getErrorWarningMessageToken } from '@/lib/socialprofiles/status';

// Types
import type { SocialProfileType } from '@/types/socialProfileType';

type ProfileTooltipProps = { profile: SocialProfileType };

export function ProfileTooltip({ profile }: ProfileTooltipProps) {
    const { isAdmin } = useUserRole();
    const profileName = profile.slug ?? profile.external_api_data?.name;
    const errorMessage = getErrorWarningMessageToken({ socialProfile: profile, isAdmin });
    const displayErrorWarningMessage =
        profile?.auth_status.type === 'error' || profile?.auth_status.type === 'warning';
    return (
        <div
            className={clsx('flex max-w-[160px] flex-col text-left text-xxs', {
                'w-40': displayErrorWarningMessage
            })}>
            <p className="truncate first-letter:capitalize">{profileName}</p>
            {profile?.auth_status.type === 'error' || profile?.auth_status.type === 'warning' ? (
                <p
                    className={clsx({
                        'text-icoOrange': profile.auth_status.type === 'warning',
                        'text-icoRed': profile.auth_status.type === 'error'
                    })}>
                    {errorMessage}
                </p>
            ) : null}
        </div>
    );
}
